
import { defineComponent } from 'vue'

export default defineComponent({
    props: {
        checked: {
            type: Boolean,
            default: false,
        },
        disabled: {
            type: Boolean,
            default: false,
        }
    },
})
